import { ReactNode } from 'react';

import { cn } from '@/lib/utils';

interface SignUpSidebarBackgroundProps {
  children: ReactNode;
  className?: string;
}

export const SignUpSidebarBackground = ({ children, className }: SignUpSidebarBackgroundProps) => {
  return (
    <div className="flex h-screen items-center justify-center">
      {children}
      <div className={cn(`absolute top-0 z-1 h-screen w-full bg-black opacity-70`, className)}></div>
      <div className="bg-grey-1 absolute top-0 -z-10 flex h-screen w-full">
        <div className="bg-default-text h-full min-w-[260px]"></div>
        <div className="w-full">
          <div className="border-grey-3 h-[54px] border-b-2 bg-white"></div>
        </div>
      </div>
    </div>
  );
};
